export default __webpack_public_path__ + "static/media/faqqa.3b9df306.svg";